namespace TR {

    class TrustpilotLogo {

        stars: number;
        count: number;
        fallbackImage: string;

        summary: any;


        constructor (private TrustpilotService: TR.TrustpilotService) {
            // get business unit info from Trustpilot
            this.TrustpilotService.getBusinessUnit().then(
                (res:any) => {
                    this.summary = res;
                }
            );

        }

    }

    angular
        .module('TR')
        .directive('trustpilotLogo', (): ng.IDirective => {

        return {
            bindToController: {
                stars: '=',
                count: '=',
                name: '@',
                class: '@',
                path: '@',
                altLogo: '=?',
            },
            controller: TrustpilotLogo,
            controllerAs: 'tpl',
            templateUrl: 'partials/home/directivetemplate?type=TrustpilotLogo',
            link: ($scope) => {
                    $scope.hostName = 'https://uk.trustpilot.com/review/www.' + TRPCONFIG.Domain.HostName;
                    setTimeout(() => {
                        let widgetManagement: any = _.get(window, 'Trustpilot.Modules.WidgetManagement');
                        if (!widgetManagement) {
                            $(document.body).append(`<script type="text/javascript"
                                src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>`);
                        }
                    }, 1500);
                }
        };

    });
}
